
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 33.333 1100 733.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ef2b2d","d":"M0 0h1100v800H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M300 0h200v800H300z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 300h1100v200H0z"}}),_c('path',{attrs:{"fill":"#002868","d":"M350 0h100v800H350z"}}),_c('path',{attrs:{"fill":"#002868","d":"M0 350h1100v100H0z"}})])
          )
        }
      }
    